async function readJsonBody(response) {
    try {
        const body = await response.clone().json();
        return typeof body === 'object' && body !== null ? body : null;
    }
    catch {
        return null;
    }
}
function toApiErrorFields(value) {
    if (typeof value !== 'object' || value === null) {
        return undefined;
    }
    const fields = {};
    for (const [key, detail] of Object.entries(value)) {
        const message = detail?.message;
        if (typeof message === 'string') {
            fields[key] = { message };
        }
    }
    return Object.keys(fields).length > 0 ? fields : undefined;
}
export class ApiError extends Error {
    name = 'ApiError';
    status;
    error;
    fields;
    response;
    constructor({ status, error, message, fields, response }) {
        super(message);
        this.status = status;
        this.error = error;
        this.fields = fields;
        this.response = response;
    }
    static async fromResponse(response) {
        const body = await readJsonBody(response);
        return new ApiError({
            status: response.status,
            error: typeof body?.error === 'string' ? body.error : response.statusText || 'Request Failed',
            message: typeof body?.message === 'string' && body.message !== ''
                ? body.message
                : `Request failed with status ${response.status}.`,
            fields: toApiErrorFields(body?.fields),
            response,
        });
    }
}
//# sourceMappingURL=api-error.js.map